import { Checkbox } from "@certa/catalyst/components/Checkbox";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { useSearchStore } from "../../store/useSearchStore";
import { filtersStyles } from "./Filters.style";
import { Spinner } from "@certa/icons/components/Spinner";
import { classNames } from "@certa/catalyst/utils/common";
import { useKinds } from "@certa/queries/hooks/kinds.hooks";
import {
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { useIntl } from "react-intl";
import { useGetKindOptions } from "../../hooks/useGetKindOptions";
import { AnalyticsEvents, analyticsService } from "@certa/analytics";

type KindFilterProps = {
  isDisabled?: boolean;
};

const KindFilter = ({ isDisabled }: KindFilterProps) => {
  const intl = useIntl();
  const { filters, setFilters } = useSearchStore();

  const { data: kindsList, isLoading: isLoadingKinds } = useKinds();

  const kindOptions = useGetKindOptions(kindsList);

  const handleChange = (kindId: string, label: string, checked: boolean) => {
    const kindIds = filters.kindIds.includes(kindId)
      ? filters.kindIds.filter(id => id !== kindId)
      : [...filters.kindIds, kindId];

    analyticsService.track(
      AnalyticsEvents.globalSearchEvents.GLOBAL_SEARCH_CATEGORY_SELECT,
      {
        value: label,
        checked,
        certa_version: "OS3",
        type: "workflow_kind"
      }
    );
    setFilters({ kindIds });
  };

  const noKindsFoundLabel = intl.formatMessage({
    id: "globalSearch.noOptionsFoundLabel",
    defaultMessage: "No options found"
  });

  return (
    <Stack
      gap="4"
      dangerouslySetClassName={classNames(
        filtersStyles.kindFilterWrapper,
        "scrollbar-on-hover"
      )}
    >
      {isLoadingKinds ? (
        <Stack
          direction="horizontal"
          align="center"
          justify="center"
          height="3rem"
        >
          <Spinner />
        </Stack>
      ) : kindOptions.length ? (
        kindOptions.map(option => (
          <Checkbox
            key={option.value}
            label={option.label}
            value={option.value}
            checked={filters.kindIds.includes(option.value)}
            onChange={checked =>
              handleChange(option.value, option.label, checked)
            }
            disabled={isDisabled}
          />
        ))
      ) : (
        <Typography
          variant={TypographyVariants.BODY}
          color={TypographyColors.NEUTRAL_700}
        >
          {noKindsFoundLabel}
        </Typography>
      )}
    </Stack>
  );
};

export { KindFilter };
